import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import AccountSettingsSection from 'components/composed/sections/AccountSettingsSection';
import ContactsSection from 'components/composed/sections/ContactsSection';

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 48px);
  width: 100%;
  background-color: ${theme.colors.linkWater};
`;

const StyledInnerContainer = styled.div`
  max-width: ${theme.spaces.large30X * 10}px;
  width: 100%;
  padding-bottom: ${theme.spaces.large10X}px;

  @media ${theme.devices.tablet} {
    padding-left: ${theme.spaces.regular}px;
    padding-right: ${theme.spaces.regular}px;
    padding-bottom: ${theme.spaces.regular}px;
  }
`;

const AccountSettingsPage = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <ContactsSection />
        <AccountSettingsSection />
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default AccountSettingsPage;
